import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 单据状态 拒绝或接受 */
    public documentStatus: string = '';
    /** 单据id */
    public documentUUID: string = '';
    /** 拒绝 弹框 */
    public refuseM: boolean = false;
    public refuseType: string = '';
    /** 拒绝理由输入 */
    public refuseInputNum: number = 0;
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/Modules.State.ts